<app-header></app-header>
<app-sidebar></app-sidebar>
<main class="full-wrap">
    <div class="main-div">
        <div class="main-section">
            <div class="row main-row">
                <div class="col-md-12">
                    <div class="main-content">
                        <div class="page-heading col-md-12">
                            <div class="page-heading-name">
                                <img src="assets/images/icon/report.svg"> <span>Reports</span>
                            </div>
                            <div class="bet-list">
                                <div class="game-header">
                                    <ul class="nav nav-pills" id="myTab" role="tablist">
                                        <li class="nav-item">
                                            <a class="nav-link" [class.active]="activeBetTab === 'openBets'"
                                                data-bs-toggle="tab" data-bs-target="#openBetsTab"
                                                (click)="tabClick('openBets')">open bets</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" data-bs-toggle="tab"
                                                [class.active]="activeBetTab === 'settledBets'"
                                                data-bs-target="#settledBetsTab"
                                                (click)="tabClick('settledBets')">settled bets</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" data-bs-toggle="tab"
                                                [class.active]="activeBetTab === 'statements'"
                                                data-bs-target="#statementTab"
                                                (click)="tabClick('statements')">statements</a>
                                        </li>

                                        <li class="nav-item">
                                            <a class="nav-link" data-bs-toggle="tab"
                                                [class.active]="activeBetTab === 'profitLoss'"
                                                data-bs-target="#profitAndLoss" (click)="tabClick('profitLoss')">profit
                                                & loss</a>
                                        </li>
                                        <!-- <li class="nav-item">
                                            <a class="nav-link" data-bs-toggle="tab"[class.active] = "activeBetTab === 'onlineGames'"
                                                data-bs-target="#onlineGamesReport">online games report</a>
                                        </li> -->
                                    </ul>
                                </div>

                            </div>
                        </div>

                        <div class="table-body report-body">

                            <div class="tab-content" id="myTabContent">

                                <div class="tab-pane fade  active " id="openBetsTab"
                                    [class.show]="activeBetTab === 'openBets'"
                                    [class.active]="activeBetTab === 'openBets'">
                                    <div class="row filter-section">
                                        <div class=" row col-md-12">
                                            <!-- <div class="col-md-1">
                                                <img src="assets/images/icon/filter-icon.png">
                                                <span>Filter</span>
                                            </div>-->
                                            <div class="form-group dateTimePicker">
                                                <!-- <input class="form-control" [max]="today" [(ngModel)]="openStartDate"
                                                    datetime="HH:mm:ss" [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1"
                                                    placeholder="Start Date Time">
                                                <owl-date-time #dt1 hour12Timer="true" showSecondsTimer="true">
                                                </owl-date-time> -->
                                                <input type="text" class="form-control" [popover]="popTemplate"
                                                    placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                                                    value="{{openStartDate | date:'yyyy-MM-dd HH:mm:ss'}}" (click)="showDate()">
                                            </div>
                                            <div class="form-group dateTimePicker">
                                                <!-- <input class="form-control" [min]="openStartDate" [max]="startAt"
                                                    [(ngModel)]="openEndDate" [owlDateTime]="dt2"
                                                    [owlDateTimeTrigger]="dt2" placeholder=" End Date Time">
                                                <owl-date-time #dt2 showSecondsTimer="true" hour12Timer="false">
                                                </owl-date-time> -->
                                                <input type="text" class="form-control" [popover]="popTemplate1"
                                                    placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                                                    value="{{openEndDate | date:'yyyy-MM-dd HH:mm:ss'}}" (click)="showDate()">
                                            </div>

                                            <!-- <div class="form-group">

                                                <input name="searchSport"
                                                    class="search-input dropdown-toggle form-control"
                                                    id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false" type="text" autocomplete="off"
                                                    [(ngModel)]="searchSport" placeholder="Search Sport Name">

                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                    <a class="dropdown-item"
                                                        *ngFor="let sport of SportList |search: searchSport :'sport_name'">
                                                        <div class="event-info"
                                                            (click)="getOpenBetFilterData(0,sport.sport_id,sport.sport_name)">
                                                            <div class="event-format-strip">
                                                                <div class="event-team">
                                                                    <div class="team-name">{{sport?.sport_name}}
                                                                       
                                                                    </div>
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </a>
                                                </div>
                                            </div>

                                            <div class="form-group mb-0">

                                                <input name="searchSeries"
                                                    class="search-input dropdown-toggle form-control"
                                                    id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false" type="text" autocomplete="off"
                                                    [(ngModel)]="searchSeries" placeholder="Search Series Name...">

                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                    <a class="dropdown-item"
                                                        *ngFor="let sport of SeriesList |search: searchSeries :'series_name'">
                                                        <div class="event-info"
                                                            (click)="getOpenBetFilterData(1,sport.series_id,sport.series_name)">
                                                            <div class="event-format-strip">
                                                                <div class="event-team">
                                                                    <div class="team-name">{{sport?.series_name}}</div>
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </a>
                                                </div>
                                            </div>

                                            <div class="form-group mb-0">

                                                <input name="searchMatch"
                                                    class="search-input dropdown-toggle form-control"
                                                    id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false" type="text" autocomplete="off"
                                                    [(ngModel)]="searchMatch" placeholder="Search Match Name...">

                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                    <a class="dropdown-item"
                                                        *ngFor="let sport of MatchList |search: searchMatch :'match_name'">
                                                        <div class="event-info"
                                                            (click)="getOpenBetFilterData(2,sport.match_id,sport.match_name)">
                                                            <div class="event-format-strip">
                                                                <div class="event-team">
                                                                    <div class="team-name">{{sport?.match_name}} </div>
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </a>
                                                </div>
                                            </div> -->
                                            <div class="col-md-1" style="width: 20%;margin:0 5px 5px 5px;">
                                    
                                                <ng-select [ngModelOptions]="{standalone: true}" [(ngModel)]="searchSport"
                                                    (change)="getOpenBetFilterData(0,searchSport.sport_id,searchSport.sport_name) "
                                                    (blur)="getOpenBetFilterData(0,searchSport.sport_id,searchSport.sport_name)" placeholder="Search Sport Name"
                                                    (clear)="getOpenBetFilterData(0,undefined,undefined)">
                                                    <ng-option *ngFor="let sport of SportList" [value]="sport">{{sport.sport_name}}</ng-option>
                                                </ng-select>
                                            </div>
                                            <div class="col-md-1" style="width: 20%;margin:0 5px;">
                                                <ng-select [ngModelOptions]="{standalone: true}" [(ngModel)]="searchSeries"
                                                    (change)="getOpenBetFilterData(1,searchSeries.series_id,searchSeries.series_name) "
                                                    (blur)="getOpenBetFilterData(1,searchSeries.series_id,searchSeries.series_name)"
                                                    placeholder="Search Series Name" (clear)="getOpenBetFilterData(1,undefined,undefined)">
                                                    <ng-option *ngFor="let series of SeriesList" [value]="series">{{series.series_name}}</ng-option>
                                                </ng-select>
                                            </div>
                                            <div class="col-md-1" style="width: 20%;margin:0 5px;">
                                                <ng-select [ngModelOptions]="{standalone: true}" [(ngModel)]="searchMatch"
                                                    (change)="getOpenBetFilterData(2,searchMatch.match_id,searchMatch.match_name) "
                                                    (blur)="getOpenBetFilterData(2,searchMatch.match_id,searchMatch.match_name)"
                                                    placeholder="Search Match Name" (clear)="getOpenBetFilterData(2,undefined,undefined)">
                                                    <ng-option *ngFor="let match of MatchList" [value]="match">{{match.match_name}}</ng-option>
                                                </ng-select>
                                            </div>
                                          
                                            <!-- <hr> -->
                                            <div class="col-md-1" style="width: 20%;margin:0 5px;">
                                                <ng-select [ngModelOptions]="{standalone: true}" [(ngModel)]="searchMarket"
                                                    (change)="(searchMarket.type == '1') ? getOpenBetFilterData(3,searchMarket.event_id,searchMarket.event_name) : getOpenBetFilterData(4,searchMarket.event_id,searchMarket.event_name) "
                                                    (blur)="(searchMarket.type == '1') ? getOpenBetFilterData(3,searchMarket.event_id,searchMarket.event_name) : getOpenBetFilterData(4,searchMarket.event_id,searchMarket.event_name)"
                                                    placeholder="Search Market Name"
                                                    (clear)="(searchMarket.type == '1') ? getOpenBetFilterData(3,undefined,undefined) :getOpenBetFilterData(4,undefined,undefined)">
                                                    <ng-option *ngFor="let event of MarketList" [value]="event">{{event.event_name}}</ng-option>
                                                </ng-select>
                                            </div>
                                        </div>
                                        <!-- <div class="form-group mb-0">

                                            <input name="searchMarket"
                                                class="search-input dropdown-toggle form-control"
                                                id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
                                                aria-expanded="false" type="text" autocomplete="off"
                                                [(ngModel)]="searchMarket" placeholder="Search Market Name...">

                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                <a class="dropdown-item"
                                                    *ngFor="let sport of MarketList |search: searchMarket :'event_name'">
                                                    <div class="event-info"
                                                        (click)="(sport.type == '1') ? getOpenBetFilterData(3,sport.event_id,'') : getOpenBetFilterData(4,sport.event_id,'')">
                                                        <div class="event-format-strip">
                                                            <div class="event-team">
                                                                <div class="team-name">{{sport?.event_name}} </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </a>
                                            </div>
                                        </div> -->
                                        <div class="right-col ">
                                            <!-- <button class="download-btn"><i class="fa fa-download"
                                                    aria-hidden="true"></i></button> -->
                                            <button class="submit-btn" (mousedown)="onClickClear()">Clear</button>
                                            <button class="submit-btn"
                                                (click)="openBets(undefined,'filterBtnClick')">Submit</button>
                                        </div>
                                    </div>
                                        <!-- <hr>
                                        <div class="row">
                                            <div class="form-group search" style="width:85%">
                                                <input class="form-control" type="text" placeholder="Search Bets" />

                                            </div>
                                            <div class="form-group text-right" style="width:10%">
                                                <select class="form-select">
                                                    <option selected value="25">10</option>
                                                    <option value="20">20</option>
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                    <option value="200">200</option>
                                                    <option value="500">500</option>
                                                </select>
                                            </div>
                                        </div> -->

                                <!-- </div> -->
                                <table *ngIf="dataSource?.length != 0" mat-table [dataSource]="dataSource"
                                    class="mat-elevation-z8">

                                    <!--- Note that these columns can be defined in any order.
                                                                                    The actual rendered columns are set as a property on the row definition" -->

                                    <!-- Position Column -->
                                    <ng-container matColumnDef="number">
                                        <th mat-header-cell *matHeaderCellDef> S.No.</th>
                                        <td mat-cell *matCellDef="let element ; let elementIndex = index;">
                                            {{(openPaginatorRef.pageIndex * openPaginatorRef.pageSize) + (elementIndex + 1)}}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="date">
                                        <th mat-header-cell *matHeaderCellDef> DATE </th>
                                        <td mat-cell *matCellDef="let element">
                                            <span class="date">{{element.createdAt | date :'dd-MM-yyyy'}} </span>
                                            <br>
                                            <span class="date">{{element.createdAt | date :'hh:mm:ss aa'}} </span>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="sport_name">
                                        <th mat-header-cell *matHeaderCellDef> SPORT | Series </th>
                                        <td mat-cell *matCellDef="let element">
                                            <span class="series-name">{{element.series_name}}</span><br>
                                            <span class="sport-name">{{element.sport_name}}</span>
                                        </td>
                                    </ng-container>
                                    <!-- <ng-container matColumnDef="series_name">
                                        <th mat-header-cell *matHeaderCellDef> SERIES </th>
                                        <td mat-cell *matCellDef="let element">{{element.series_name}} </td>
                                    </ng-container> -->
                                    <!-- Name Column -->
                                    <ng-container matColumnDef="events">
                                        <th mat-header-cell *matHeaderCellDef> EVENTS | Market </th>
                                        <td mat-cell *matCellDef="let element">
                                            <span class="match-name">{{element.match_name}} </span> <br>
                                            <span class="market-name">{{element.market_name}} </span>
                                        </td>
                                    </ng-container>
                                    <!-- <ng-container matColumnDef="market">
                                        <th mat-header-cell *matHeaderCellDef> MARKET</th>
                                        <td mat-cell *matCellDef="let element"> <span class="event-column">{{element.market_name}} </span></td>
                                    </ng-container> -->
                                    <!-- selection Column -->
                                    <ng-container matColumnDef="selection">
                                        <th mat-header-cell *matHeaderCellDef> SELECTION | TYpe </th>
                                        <td mat-cell *matCellDef="let element">
                                            <span class="selection">{{element.selection_name}}</span> <br>
                                            <span class="back-btn" *ngIf="element.is_back == 0">Back</span>
                                            <span class="lay-btn" *ngIf="element.is_back == 1">Lay</span>
                                        </td>
                                    </ng-container>
                                    <!-- <ng-container matColumnDef="is_back">
                                        <th mat-header-cell *matHeaderCellDef> TYPE </th>
                                        <td mat-cell *matCellDef="let element">
                                            <span class="back-btn" *ngIf="element.is_back == 0">BACK</span>
                                            <span class="lay-btn" *ngIf="element.is_back == 1">LAY</span>
                                        </td>
                                    </ng-container> -->
                                    <!-- odds Column -->
                                    <ng-container matColumnDef="odds">
                                        <th mat-header-cell *matHeaderCellDef> ODDS </th>
                                        <td mat-cell *matCellDef="let element"> {{element.odds| number : '0.0-2'}}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="stake">
                                        <th mat-header-cell *matHeaderCellDef> STAKE </th>
                                        <td mat-cell *matCellDef="let element"> <span class="stake">{{element.stack|
                                                number : '0.0-2'}} </span> </td>
                                    </ng-container>
                                    <ng-container matColumnDef="pl">
                                        <th mat-header-cell *matHeaderCellDef> P & L </th>
                                        <td mat-cell *matCellDef="let element"> <span
                                                [ngClass]="{'loss':bet?.p_l < 0 ,'profit':bet?.p_l >= 0}">{{element.p_l|
                                                number : '0.0-2'}} </span></td>

                                    </ng-container>


                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                </table>
                                <mat-paginator [ngClass]="{'hide':openBetsLength == 0 ,'show':openBetsLength !=0}"
                                    [length]="totalItems" [pageSize]="pageSize" [pageIndex]="openBetPageIndex"
                                    [pageSizeOptions]="[50, 100,150, 200]" #openPaginatorRef
                                    aria-label="Select page" (page)="openBets($event)">
                                </mat-paginator>
                                <div class="no-data-section row justify-content-center"
                                    *ngIf="dataSource?.length == 0">

                                    <img src="assets/icons/mood_bad_black.png">
                                    <h1>Game History</h1>
                                    <label>There is no data to display</label>
                                </div>

                            </div>
                            <div class="tab-pane fade " id="settledBetsTab"
                                [class.show]="activeBetTab === 'settledBets'"
                                [class.active]="activeBetTab === 'settledBets'">
                                <div class="row filter-section">
                                    <div class=" row col-md-12">
                                        <div class=" row col-md-9"  style="width: 78%;margin:0 5px;">
                                        <!-- <div class="col-md-1">
                                            <img src="assets/images/icon/filter-icon.png">
                                            <span>Filter</span>
                                        </div>-->
                                        <div class="form-group dateTimePicker">
                                            <!-- <input class="form-control" [max]="today" [(ngModel)]="settledStartDate"
                                                [owlDateTime]="dt3" [owlDateTimeTrigger]="dt3"
                                                placeholder=" Start Date Time">
                                            <owl-date-time #dt3 showSecondsTimer="true"></owl-date-time> -->
                                            <input type="text" class="form-control" [popover]="popTemplateSettledStart"
                                                placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                                                value="{{settledStartDate | date:'yyyy-MM-dd HH:mm:ss'}}" (click)="showDate()">
                                        </div>
                                        <div class="form-group dateTimePicker">
                                            <!-- <input class="form-control" [min]="settledStartDate" [max]="startAt"
                                                [(ngModel)]="settledEndDate" [owlDateTime]="dt4"
                                                [owlDateTimeTrigger]="dt4" placeholder=" End Date Time">
                                            <owl-date-time #dt4 showSecondsTimer="true"></owl-date-time> -->
                                            <input type="text" class="form-control" [popover]="popTemplateSettledEnd"
                                                placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                                                value="{{settledEndDate | date:'yyyy-MM-dd HH:mm:ss'}}" (click)="showDate()">
                                        </div>

                                        <!-- <div class="form-group">

                                            <input name="searchSport"
                                                class="search-input dropdown-toggle form-control"
                                                id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
                                                aria-expanded="false" type="text" autocomplete="off"
                                                [(ngModel)]="searchSport" placeholder="Search Sport Name">

                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                <a class="dropdown-item"
                                                    *ngFor="let sport of SportList |search: searchSport :'sport_name'">
                                                    <div class="event-info"
                                                        (click)="getSettledBetFilterData(0,sport.sport_id,sport.sport_name)">
                                                        <div class="event-format-strip">
                                                            <div class="event-team">
                                                                <div class="team-name">{{sport?.sport_name}}
                                                                    
                                                                </div>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </a>
                                            </div>
                                        </div>

                                        <div class="form-group mb-0">

                                            <input name="searchSeries"
                                                class="search-input dropdown-toggle form-control"
                                                id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
                                                aria-expanded="false" type="text" autocomplete="off"
                                                [(ngModel)]="searchSeries" placeholder="Search Series Name...">

                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                <a class="dropdown-item"
                                                    *ngFor="let sport of SeriesList |search: searchSeries :'series_name'">
                                                    <div class="event-info"
                                                        (click)="getSettledBetFilterData(1,sport.series_id,sport.series_name)">
                                                        <div class="event-format-strip">
                                                            <div class="event-team">
                                                                <div class="team-name">{{sport?.series_name}}</div>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </a>
                                            </div>
                                        </div>

                                        <div class="form-group mb-0">

                                            <input name="searchMatch"
                                                class="search-input dropdown-toggle form-control"
                                                id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
                                                aria-expanded="false" type="text" autocomplete="off"
                                                [(ngModel)]="searchMatch" placeholder="Search Match Name...">

                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                <a class="dropdown-item"
                                                    *ngFor="let sport of MatchList |search: searchMatch :'match_name'">
                                                    <div class="event-info"
                                                        (click)="getSettledBetFilterData(2,sport.match_id,sport.match_name)">
                                                        <div class="event-format-strip">
                                                            <div class="event-team">
                                                                <div class="team-name">{{sport?.match_name}} </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div> -->
                                        <div class="col-md-1" style="width:20%;margin:0 5px 5px 5px;">
                                
                                            <ng-select [ngModelOptions]="{standalone: true}" [(ngModel)]="searchSport"
                                                (change)="getSettledBetFilterData(0,searchSport.sport_id,searchSport.sport_name) "
                                                (blur)="getSettledBetFilterData(0,searchSport.sport_id,searchSport.sport_name)" placeholder="Search Sport Name"
                                                (clear)="getSettledBetFilterData(0,undefined,undefined)">
                                                <ng-option *ngFor="let sport of SportList" [value]="sport">{{sport.sport_name}}</ng-option>
                                            </ng-select>
                                        </div>
                                        <div class="col-md-1" style="width:20%;margin:0 5px;">
                                            <ng-select [ngModelOptions]="{standalone: true}" [(ngModel)]="searchSeries"
                                                (change)="getSettledBetFilterData(1,searchSeries.series_id,searchSeries.series_name) "
                                                (blur)="getSettledBetFilterData(1,searchSeries.series_id,searchSeries.series_name)"
                                                placeholder="Search Series Name" (clear)="getSettledBetFilterData(1,undefined,undefined)">
                                                <ng-option *ngFor="let series of SeriesList" [value]="series">{{series.series_name}}</ng-option>
                                            </ng-select>
                                        </div>
                                        <div class="col-md-1" style="width:20%;margin:0 5px;">
                                            <ng-select [ngModelOptions]="{standalone: true}" [(ngModel)]="searchMatch"
                                                (change)="getSettledBetFilterData(2,searchMatch.match_id,searchMatch.match_name) "
                                                (blur)="getSettledBetFilterData(2,searchMatch.match_id,searchMatch.match_name)"
                                                placeholder="Search Match Name" (clear)="getSettledBetFilterData(2,undefined,undefined)">
                                                <ng-option *ngFor="let match of MatchList" [value]="match">{{match.match_name}}</ng-option>
                                            </ng-select>
                                        </div>
                                        
                                        
                                        <div class="col-md-1" style="width: 20%;margin:0 5px;">
                                            <ng-select [ngModelOptions]="{standalone: true}" [(ngModel)]="searchMarket"
                                                (change)="(searchMarket.type == '1') ? getSettledBetFilterData(3,searchMarket.event_id,searchMarket.event_name) : getSettledBetFilterData(4,searchMarket.event_id,searchMarket.event_name) "
                                                (blur)="(searchMarket.type == '1') ? getSettledBetFilterData(3,searchMarket.event_id,searchMarket.event_name) : getSettledBetFilterData(4,searchMarket.event_id,searchMarket.event_name)"
                                                placeholder="Search Market Name"
                                                (clear)="(searchMarket.type == '1') ? getSettledBetFilterData(3,undefined,undefined) :getSettledBetFilterData(4,undefined,undefined)">
                                                <ng-option *ngFor="let event of MarketList" [value]="event">{{event.event_name}}</ng-option>
                                            </ng-select>
                                        </div>
                                        </div>
                                        <!-- <div class="form-group mb-0">

                                            <input name="searchMarket"
                                                class="search-input dropdown-toggle form-control"
                                                id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
                                                aria-expanded="false" type="text" autocomplete="off"
                                                [(ngModel)]="searchMarket" placeholder="Search Market Name...">

                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                <a class="dropdown-item"
                                                    *ngFor="let sport of MarketList |search: searchMarket :'event_name'">
                                                    <div class="event-info"
                                                        (click)="(sport.type == '1') ? getSettledBetFilterData(3,sport.event_id,'') : getSettledBetFilterData(4,sport.event_id,'')">
                                                        <div class="event-format-strip">
                                                            <div class="event-team">
                                                                <div class="team-name">{{sport?.event_name}} </div>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </a>
                                            </div>
                                        </div> -->
                                        <div class="right-col">
                                            <!-- <button class="download-btn"><i class="fa fa-download"
                                                                                                aria-hidden="true"></i></button> -->
                                            <button class="submit-btn" (mousedown)="onClickClear()">Clear</button>
                                            <button class="submit-btn"
                                                (click)="settledBets(undefined,'filterBtnClick')">Submit</button>
                                        </div>
                                    </div>


                                </div>
                                <table *ngIf="settledBetDataSource?.length != 0" mat-table
                                    [dataSource]="settledBetDataSource" class="mat-elevation-z8">
                                    <ng-container matColumnDef="number">
                                        <th mat-header-cell *matHeaderCellDef> S.No.</th>
                                        <td mat-cell *matCellDef="let element ; let elementIndex = index;">
                                            {{(settledPaginatorRef.pageIndex * settledPaginatorRef.pageSize) + (elementIndex + 1)}}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="date">
                                        <th mat-header-cell *matHeaderCellDef> DATE </th>
                                        <td mat-cell *matCellDef="let element">
                                            <span class="date">{{element.createdAt | date :'dd-MM-yyyy'}} </span>
                                            <br>
                                            <span class="date">{{element.createdAt | date :'hh:mm:ss aa'}} </span>
                                        </td>
                                    </ng-container>
                                    <!-- Position Column -->
                                    <ng-container matColumnDef="sport_name">
                                        <th mat-header-cell *matHeaderCellDef> SPORT | SERIES</th>
                                        <td mat-cell *matCellDef="let element">
                                            <span class="series-name">{{element.series_name}}</span><br>
                                            <span class="sport-name">{{element.sport_name}} </span>
                                        </td>
                                    </ng-container>
                                    <!-- <ng-container matColumnDef="series_name">
                                        <th mat-header-cell *matHeaderCellDef> SERIES </th>
                                        <td mat-cell *matCellDef="let element"> </td>
                                    </ng-container> -->
                                    <!-- Name Column -->
                                    <ng-container matColumnDef="events">
                                        <th mat-header-cell *matHeaderCellDef> EVENTS | MARKET</th>
                                        <td mat-cell *matCellDef="let element">
                                            <span class="match-name">{{element.match_name}}</span><br>
                                            <span class="market-name">{{element.market_name}}</span>
                                        </td>
                                    </ng-container>
                                    <!-- <ng-container matColumnDef="market" style="width:10%">
                                        <th mat-header-cell *matHeaderCellDef> MARKET </th>
                                        <td mat-cell *matCellDef="let element"> <span class="event-column" >{{element.market_name}}</span> </td>
                                    </ng-container> -->

                                    <!-- selection Column -->
                                    <ng-container matColumnDef="selection">
                                        <th mat-header-cell *matHeaderCellDef> SELECTION | TYPE </th>
                                        <td mat-cell *matCellDef="let element">
                                            <span class="selection">{{element.selection_name}}</span><br>
                                            <span class="back-btn" *ngIf="element.is_back == 1">Back</span>
                                            <span class="lay-btn" *ngIf="element.is_back == 0">Lay</span>
                                        </td>
                                    </ng-container>
                                    <!-- <ng-container matColumnDef="is_back">
                                        <th mat-header-cell *matHeaderCellDef> TYPE </th>
                                        <td mat-cell *matCellDef="let element">
                                            <span class="back-btn" *ngIf="element.is_back == 0">BACK</span>
                                            <span class="lay-btn" *ngIf="element.is_back == 1">LAY</span>
                                        </td>
                                    </ng-container> -->
                                    <!-- odds Column -->
                                    <ng-container matColumnDef="odds">
                                        <th mat-header-cell *matHeaderCellDef> ODDS </th>
                                        <td mat-cell *matCellDef="let element"> {{element.odds| number : '0.0-2'}}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="stake">
                                        <th mat-header-cell *matHeaderCellDef> STAKE </th>
                                        <td mat-cell *matCellDef="let element"> <span class="stake">{{element.stack|
                                                number : '0.0-2'}}</span> </td>
                                    </ng-container>
                                    <ng-container matColumnDef="profit">
                                        <th mat-header-cell *matHeaderCellDef> P|L </th>
                                        <td mat-cell *matCellDef="let element"> <span
                                                [ngClass]="{'loss':element?.p_l < 0 ,'profit':element?.p_l >= 0}">{{element.p_l|
                                                number : '0.0-2'}} </span></td>
                                    </ng-container>
                                    <ng-container matColumnDef="result">
                                        <th mat-header-cell *matHeaderCellDef> Result </th>
                                        <td mat-cell *matCellDef="let element"> <span>{{element.winner_name}} </span></td>
                                    </ng-container>

                                    <!-- <ng-container matColumnDef="loss">
                                        <th mat-header-cell *matHeaderCellDef>  </th>
                                        <td mat-cell *matCellDef="let element">  <span class="loss">{{element.loss}} </span></td>
                                    </ng-container>
                                    <ng-container matColumnDef="commission">
                                        <th mat-header-cell *matHeaderCellDef> COMMISSION </th>
                                        <td mat-cell *matCellDef="let element">  <span class="commission">{{element.commission}} </span></td>
                                    </ng-container>
                                    <ng-container matColumnDef="total">
                                        <th mat-header-cell *matHeaderCellDef> TOTAL P & L </th>
                                        <td mat-cell *matCellDef="let element">  <span class="total">{{element.total}} </span></td>
                                    </ng-container>
                                    <ng-container matColumnDef="status">
                                        <th mat-header-cell *matHeaderCellDef> STATUS </th>
                                        <td mat-cell *matCellDef="let element">  <span class="status">{{element.status}} </span></td>
                                    </ng-container> -->

                                    <tr mat-header-row *matHeaderRowDef="settledBetdisplayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: settledBetdisplayedColumns;"></tr>
                                </table>
                                <mat-paginator [length]="settledBetsTotalItems" [pageSize]="pageSize"
                                    [pageIndex]="settledBetsPageIndex" #settledPaginatorRef
                                    [pageSizeOptions]="[50, 100,150, 200]"
                                    [ngClass]="{'hide':settledBetsLength==0 ,'show':settledBetsLength!=0}"
                                    aria-label="Select page" (page)="settledBets($event)">
                                </mat-paginator>
                                <div class="no-data-section row justify-content-center"
                                    *ngIf="settledBetDataSource?.length == 0">

                                    <img src="assets/icons/mood_bad_black.png">
                                    <h1>Game History</h1>
                                    <label>There is no data to display</label>
                                </div>
                            </div>
                            <div class="tab-pane fade " id="statementTab"
                                [class.show]="activeBetTab === 'statements'"
                                [class.active]="activeBetTab === 'statements'">
                                <div class="row filter-section">
                                    <div class=" row col-md-12">
                                        <div class="col-md-1">
                                            <img src="assets/images/icon/filter-icon.png">
                                            <span>Filter</span>
                                        </div>
                                        <div class=" col-md-4 filter-btn">
                                            <div class="form-check"
                                                *ngFor="let type of statementType| keyvalue; let i = index;">
                                                <input name="{{type.value}}" [value]='type.key' id='{{type.value}}'
                                                    [(ngModel)]="selections" type="radio"
                                                    (ngModelChange)="onSelectionChange(type.key)" (checked)="true">
                                                <label class="form-check-label" for="{{type.value}}"
                                                    (keyup.space)="radioSelected=type.key">{{type.value}} </label>
                                            </div>

                                        </div>
                                        <div class="form-group dateTimePicker">
                                            <!-- <input class="form-control" [max]="today"
                                                [(ngModel)]="statementStartDate" [owlDateTime]="dt7"
                                                [owlDateTimeTrigger]="dt7" placeholder=" Start Date Time">
                                            <owl-date-time #dt7 showSecondsTimer="true"></owl-date-time> -->
                                            <input type="text" class="form-control" [popover]="popTemplateStatementStart"
                                                placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                                                value="{{statementStartDate | date:'yyyy-MM-dd HH:mm:ss'}}" (click)="showDate()">
                                        </div>
                                        <div class="form-group dateTimePicker">
                                            <!-- <input class="form-control" [min]="statementStartDate" [max]="startAt"
                                                [(ngModel)]="statementEndDate" [owlDateTime]="dt8"
                                                [owlDateTimeTrigger]="dt8" placeholder=" End Date Time">
                                            <owl-date-time #dt8 showSecondsTimer="true"></owl-date-time> -->
                                            <input type="text" class="form-control" [popover]="popTemplateStatementEnd"
                                                placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                                                value="{{statementEndDate | date:'yyyy-MM-dd HH:mm:ss'}}" (click)="showDate()">
                                        </div>

                                        <div class="right-col col-md-3">
                                            <button class="submit-btn" (mousedown)="onClickClear()">Clear</button>
                                            <button class="submit-btn"
                                                (click)="getStatement(undefined,'filterBtnClick')">Submit</button>
                                        </div>
                                    </div>


                                </div>
                                <table mat-table *ngIf="!showMatchTable && statementsDataSource?.length != 0"
                                    [dataSource]="statementsDataSource" class="mat-elevation-z8">
                                    <!--- Note that these columns can be defined in any order. -->

                                    <!-- Name Column -->
                                    <ng-container matColumnDef="number">
                                        <th mat-header-cell *matHeaderCellDef> S.No.</th>
                                        <td mat-cell *matCellDef="let element ; let elementIndex = index;">
                                            {{(statementPaginatorRef.pageIndex * statementPaginatorRef.pageSize) + (elementIndex + 1)}}
                                        </td>
                                        <td mat-footer-cell *matFooterCellDef> </td>
                                    </ng-container>
                                    <ng-container matColumnDef="date">
                                        <th mat-header-cell *matHeaderCellDef> DATE </th>
                                        <td mat-cell *matCellDef="let element" class="date-column">
                                            <span class="date">{{element.date | date :'dd-MM-yyyy'}} </span> <br>
                                            <span class="date">{{element.date | date :'hh:mm:ss aa'}} </span>
                                        </td>
                                        <td mat-footer-cell *matFooterCellDef> </td>
                                    </ng-container>
                                    <ng-container matColumnDef="credit">
                                        <th mat-header-cell *matHeaderCellDef> Deposit </th>
                                        <td mat-cell *matCellDef="let element"> <span
                                                [ngClass]="{'profit':element.credit_debit >= 0}">
                                                {{element.credit_debit > '0' ? (element.credit_debit | number :
                                                '0.0-2') : '0'}}</span> </td>
                                        <td mat-footer-cell *matFooterCellDef>
                                            <!-- <span [ngClass]="{'profit':getTotalCredits() >= 0}">{{getTotalCredits() | number : '0.0-2'}}</span> -->
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="debit">
                                        <th mat-header-cell *matHeaderCellDef> Withdrawl </th>
                                        <td mat-cell *matCellDef="let element"> <span
                                                [ngClass]="{'loss':element.credit_debit < 0}">
                                                {{element.credit_debit < '0' ? (element.credit_debit | number
                                                    : '0.0-2' ) : '0' }}</span>
                                        </td>
                                        <td mat-footer-cell *matFooterCellDef>
                                            <!-- <span style="padding:0 5px;" [ngClass]="{'loss':getTotalDebits() < 0}">{{getTotalDebits() | number : '0.0-2'}}</span> -->
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="balance"
                                        *ngIf="this.selections == '1' || this.selections == '4' || this.selections == '0' ">
                                        <th mat-header-cell *matHeaderCellDef> BALANCE </th>
                                        <td mat-cell *matCellDef="let element"> <span
                                                [ngClass]="{'loss':element.balance < 0 ,'profit':element.balance >= 0}">{{element.balance|
                                                number :
                                                '0.0-2'}}</span> </td>
                                        <td mat-footer-cell *matFooterCellDef>
                                            <!-- <span  [ngClass]="{'loss':getTotalStatementBalance()< 0 ,'profit':getTotalStatementBalance() >= 0}">{{getTotalStatementBalance()| number : '0.0-2'}}</span> -->
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="remark">
                                        <th mat-header-cell *matHeaderCellDef> REMARK </th>
                                        <td mat-cell *matCellDef="let element"> {{element.remark}}</td>
                                        <td mat-footer-cell *matFooterCellDef> </td>
                                    </ng-container>
                                    <!-- selection Column -->
                                    <ng-container matColumnDef="description">
                                        <th mat-header-cell *matHeaderCellDef> From / To </th>
                                        <td mat-cell *matCellDef="let element"><span
                                                class="dec-cell">{{element.description}}</span> </td>
                                        <td mat-footer-cell *matFooterCellDef> </td>
                                    </ng-container>

                                    <!-- odds Column -->
                                    


                                    <tr mat-header-row *matHeaderRowDef="statementsdisplayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: statementsdisplayedColumns;"></tr>
                                    <tr mat-footer-row *matFooterRowDef="statementsdisplayedColumns; sticky: true">
                                    </tr>
                                </table>
                                <div class="no-data-section row justify-content-center"
                                    *ngIf="statementsDataSource?.length == 0">

                                    <img src="assets/icons/mood_bad_black.png">
                                    <h1>Game History</h1>
                                    <label>There is no data to display</label>
                                </div>
                                <!-- <div *ngIf="statementsData?.length != 0"> -->
                                <mat-paginator [ngClass]="{'hide':statementsLength==0 ,'show':statementsLength!=0}"
                                    [length]="statementsTotalItems" [pageSize]="50" #statementPaginatorRef
                                    [pageIndex]="statementsPageIndex" [pageSizeOptions]="[50, 100,150, 200]"
                                    aria-label="Select page" (page)="getStatement($event)">
                                </mat-paginator>
                                <!-- </div> -->




                            </div>
                            <div class="tab-pane fade " id="profitAndLoss"
                                [class.show]="activeBetTab === 'profitLoss'"
                                [class.active]="activeBetTab === 'profitLoss'">
                                <div class="row filter-section">
                                    <div class=" row col-md-12">
                                        <!-- <div class="col-md-1">
                                            <img src="assets/images/icon/filter-icon.png">
                                            <span>Filter</span>
                                        </div> -->
                                        <div class="form-group dateTimePicker">
                                            <!-- <input class="form-control" [max]="today" [(ngModel)]="profitStartDate"
                                                [owlDateTime]="dt5" [owlDateTimeTrigger]="dt5"
                                                placeholder=" Start Date Time">
                                            <owl-date-time #dt5 showSecondsTimer="true"></owl-date-time> -->
                                            <input type="text" class="form-control" [popover]="popTemplateProfitStart"
                                                placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                                                value="{{profitStartDate | date:'yyyy-MM-dd HH:mm:ss'}}" (click)="showDate()">
                                        </div>
                                        <div class="form-group dateTimePicker">
                                            <!-- <input class="form-control" [min]="profitStartDate" [max]="startAt"
                                                [(ngModel)]="profitEndDate" [owlDateTime]="dt6"
                                                [owlDateTimeTrigger]="dt6" placeholder=" End Date Time">
                                            <owl-date-time #dt6 showSecondsTimer="true"></owl-date-time> -->
                                            <input type="text" class="form-control" [popover]="popTemplateProfitEnd"
                                                placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                                                value="{{profitEndDate | date:'yyyy-MM-dd HH:mm:ss'}}" (click)="showDate()">
                                        </div>
                                        <!-- <div class="form-group">
                                        
                                            <input name="searchSport" class="search-input dropdown-toggle form-control" id="dropdownMenuLink"
                                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" type="text" autocomplete="off"
                                                [(ngModel)]="searchSport" placeholder="Search Sport Name">

                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                <a class="dropdown-item"
                                                    *ngFor="let sport of SportList |search: searchSport :'sport_name'">
                                                    <div class="event-info"
                                                        (click)="getProfitLossFilterData(0,sport.sport_id,sport.sport_name)">
                                                        <div class="event-format-strip">
                                                            <div class="event-team">
                                                                <div class="team-name">{{sport?.sport_name}}
                                                                    
                                                                </div>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </a>
                                            </div>
                                        </div> -->
                                        <div class="col-md-1" style="width: 15.499999995%;margin:0 5px;">
                                            <ng-select [ngModelOptions]="{standalone: true}" [(ngModel)]="searchSport"
                                                (change)="getProfitLossFilterData(0,searchSport.sport_id,searchSport.sport_name) "
                                                (blur)="getProfitLossFilterData(0,searchSport.sport_id,searchSport.sport_name)" placeholder="Search Sport Name"
                                                (clear)="getProfitLossFilterData(0,undefined,undefined)">
                                                <ng-option *ngFor="let sport of SportList" [value]="sport">{{sport.sport_name}}</ng-option>
                                            </ng-select>
                                        </div>
                                        <div class="col-md-1" style="width: 15.499999995%;margin:0 5px;">
                                            <ng-select [ngModelOptions]="{standalone: true}" [(ngModel)]="searchSeries"
                                                (change)="getProfitLossFilterData(1,searchSeries.series_id,searchSeries.series_name) "
                                                (blur)="getProfitLossFilterData(1,searchSeries.series_id,searchSeries.series_name)"
                                                placeholder="Search Series Name" (clear)="getProfitLossFilterData(1,undefined,undefined)">
                                                <ng-option *ngFor="let series of SeriesList" [value]="series">{{series.series_name}}</ng-option>
                                            </ng-select>
                                        </div>
                                        <div class="col-md-1" style="width: 15.499999995%;margin:0 5px;">
                                            <ng-select [ngModelOptions]="{standalone: true}" [(ngModel)]="searchMatch"
                                                (change)="getProfitLossFilterData(2,searchMatch.match_id,searchMatch.match_name) "
                                                (blur)="getProfitLossFilterData(2,searchMatch.match_id,searchMatch.match_name)"
                                                placeholder="Search Match Name" (clear)="getProfitLossFilterData(2,undefined,undefined)">
                                                <ng-option *ngFor="let match of MatchList" [value]="match">{{match.match_name}}</ng-option>
                                            </ng-select>
                                        </div>
                                        <!-- <div class="form-group mb-0">
                                        
                                            <input name="searchSeries" class="search-input dropdown-toggle form-control" id="dropdownMenuLink"
                                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" type="text" autocomplete="off"
                                                [(ngModel)]="searchSeries" placeholder="Search Series Name...">

                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                <a class="dropdown-item"
                                                    *ngFor="let sport of SeriesList |search: searchSeries :'series_name'">
                                                    <div class="event-info"
                                                        (click)="getProfitLossFilterData(1,sport.series_id,sport.series_name)">
                                                        <div class="event-format-strip">
                                                            <div class="event-team">
                                                                <div class="team-name">{{sport?.series_name}}</div>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </a>
                                            </div>
                                        </div>

                                        <div class="form-group mb-0">

                                            <input name="searchMatch"
                                                class="search-input dropdown-toggle form-control"
                                                id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
                                                aria-expanded="false" type="text" autocomplete="off"
                                                [(ngModel)]="searchMatch" placeholder="Search Match Name...">

                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                <a class="dropdown-item"
                                                    *ngFor="let sport of MatchList |search: searchMatch :'match_name'">
                                                    <div class="event-info"
                                                        (click)="getProfitLossFilterData(2,sport.match_id,sport.match_name)">
                                                        <div class="event-format-strip">
                                                            <div class="event-team">
                                                                <div class="team-name">{{sport?.match_name}} </div>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </a>
                                            </div>
                                        </div> -->
                                        <hr>
                                        <!-- <div class="form-group mb-0">
                                        
                                            <input name="searchMarket" class="search-input dropdown-toggle form-control" id="dropdownMenuLink"
                                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" type="text" autocomplete="off"
                                                [(ngModel)]="searchMarket" placeholder="Search Market Name...">

                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                <a class="dropdown-item"
                                                    *ngFor="let sport of MarketList |search: searchMarket :'event_name'">
                                                    <div class="event-info"
                                                        (click)="(sport.type == '1') ? filterProfitLossData(sport.event_id,3) : filterProfitLossData(sport.event_id,4)">
                                                        <div class="event-format-strip">
                                                            <div class="event-team">
                                                                <div class="team-name">{{sport?.event_name}} </div>
                                                            </div>
                                                            
                                                        </div>

                                                    </div>
                                                </a>
                                            </div>
                                        </div> -->
                                        <div class="col-md-1" style="width: 15.499999995%;margin:0 5px;">
                                            <ng-select [ngModelOptions]="{standalone: true}" [(ngModel)]="searchMarket"
                                                (change)="(searchMarket.type == '1') ? filterProfitLossData(searchMarket.event_id,3) : filterProfitLossData(searchMarket.event_id,4)"
                                                (blur)="(searchMarket.type == '1') ? filterProfitLossData(searchMarket.event_id,3) : filterProfitLossData(searchMarket.event_id,4)"
                                                placeholder="Search Market Name"
                                                (clear)="(searchMarket.type == '1') ? filterProfitLossData(searchMarket.event_id,3) : filterProfitLossData(searchMarket.event_id,4)">
                                                <ng-option *ngFor="let event of MarketList" [value]="event">{{event.event_name}}</ng-option>
                                            </ng-select>
                                            </div>
                                        <div class="right-col col-md-10">
                                            <!-- <button class="download-btn"><i class="fa fa-download"
                                                                                                aria-hidden="true"></i></button> -->
                                            <button class="submit-btn" (mousedown)="onClickClear()" >Clear</button>
                                            <button class="submit-btn" (click)="filterProfitLossData('',null,'filterBtnClick')">Submit</button>
                                        </div>
                                    </div>
                                    <!-- <hr>
                                    <div class="row">
                                        <div class="form-group search" style="width:85%">
                                            <input class="form-control" type="text" placeholder="Search Bets" />

                                        </div>
                                        <div class="form-group text-right" style="width:10%">
                                            <select class="form-select">
                                                <option selected value="25">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                                <option value="200">200</option>
                                                <option value="500">500</option>
                                            </select>
                                        </div>
                                    </div> -->

                                </div>
                                <table mat-table *ngIf="profitandlossDataSource?.length != 0"
                                    [dataSource]="profitandlossDataSource" class="mat-elevation-z8">
                                    <ng-container matColumnDef="number">
                                        <th mat-header-cell *matHeaderCellDef> S.No.</th>
                                        <td mat-cell *matCellDef="let element ; let elementIndex = index;">
                                            {{(profitPaginatorRef.pageIndex * profitPaginatorRef.pageSize) + (elementIndex + 1)}}
                                        </td>
                                        <td mat-footer-cell *matFooterCellDef> </td>
                                    </ng-container>
                                    <ng-container matColumnDef="result_date">
                                        <th mat-header-cell *matHeaderCellDef>Date</th>
                                        <td mat-cell *matCellDef="let element">
                                            <span class="date">{{element.result_date | date :'dd-MM-yyyy'}} </span>
                                            <br>
                                            <span class="date">{{element.result_date | date :'hh:mm:ss aa'}} </span>
                                        </td>
                                        <td mat-footer-cell *matFooterCellDef> </td>
                                    </ng-container>

                                    <!-- Name Column -->
                                    <ng-container matColumnDef="sport_name">
                                        <th mat-header-cell *matHeaderCellDef> Sports | Series </th>
                                        <td mat-cell *matCellDef="let element">
                                            <span class="series-name">{{element.series_name}} </span> <br>
                                            <span class="sport-name">{{element.sport_name}}</span>
                                        </td>
                                        <td mat-footer-cell *matFooterCellDef> </td>
                                    </ng-container>

                                    <!-- selection Column -->
                                    <!-- <ng-container matColumnDef="series_name">
                                        <th mat-header-cell *matHeaderCellDef>Series</th>
                                        <td mat-cell *matCellDef="let element"> <span>{{element.series_name}} </span></td>
                                        <td mat-footer-cell *matFooterCellDef>  </td>
                                    </ng-container> -->
                                    <ng-container matColumnDef="match_name">
                                        <th mat-header-cell *matHeaderCellDef>Match | Market</th>
                                        <td mat-cell *matCellDef="let element">
                                            <span class="match-name">{{element.match_name}} </span><br>
                                            <span class="event-name">{{element.event_name}} </span>
                                        </td>
                                        <td mat-footer-cell *matFooterCellDef> </td>
                                    </ng-container>

                                    <!-- <ng-container matColumnDef="event_name">
                                        <th mat-header-cell *matHeaderCellDef>Market</th>
                                        <td mat-cell *matCellDef="let element"> <span>{{element.event_name}} </span></td>
                                        <td mat-footer-cell *matFooterCellDef>  </td>
                                    </ng-container> -->

                                    <ng-container matColumnDef="user_pl">
                                        <th mat-header-cell *matHeaderCellDef>P | L </th>
                                        <td mat-cell *matCellDef="let element"> <span
                                                [ngClass]="{'loss':element.user_pl < 0 ,'profit':element.user_pl >= 0}">{{element.user_pl|
                                                number : '0.0-2'}} </span></td>
                                        <td mat-footer-cell *matFooterCellDef> <span
                                                [ngClass]="{'loss':getTotalPL() < 0 ,'profit':getTotalPL() >= 0}"
                                                style="padding: 0 5px;">{{getTotalPL()| number : '0.0-2' }}</span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="user_commission_pl">
                                        <th mat-header-cell *matHeaderCellDef>Commission</th>
                                        <td mat-cell *matCellDef="let element"> <span
                                                [ngClass]="{'loss':element.user_commission_pl < 0 ,'profit':element.user_commission_pl >= 0}">{{element.user_commission_pl|
                                                number : '0.0-2'}} </span></td>
                                        <td mat-footer-cell *matFooterCellDef> <span
                                                [ngClass]="{'loss':getTotalCommission()  < 0 ,'profit':getTotalCommission()  >= 0}">{{getTotalCommission()
                                                | number : '0.0-2'}}</span> </td>
                                    </ng-container>
                                    <ng-container matColumnDef="net_pl">
                                        <th mat-header-cell *matHeaderCellDef> Net PNL </th>
                                        <td mat-cell *matCellDef="let element"> <span
                                                [ngClass]="{'loss':element.net_pl < 0 ,'profit':element.net_pl >= 0}">{{element.net_pl|
                                                number : '0.0-2'}} </span></td>
                                        <td mat-footer-cell *matFooterCellDef> <span
                                                [ngClass]="{'loss':getTotalNetPl() < 0 ,'profit':getTotalNetPl() >= 0}">{{getTotalNetPl()|
                                                number : '0.0-2'}}</span> </td>
                                    </ng-container><ng-container matColumnDef="result">
                                        <th mat-header-cell *matHeaderCellDef> Result </th>
                                        <td mat-cell *matCellDef="let element"> <span>{{element.winner_name}} </span></td>
                                        <td mat-footer-cell *matFooterCellDef> </td>
                                    </ng-container>

                                    <ng-container matColumnDef="match_id">
                                        <th mat-header-cell *matHeaderCellDef> View Bets</th>
                                        <td mat-cell *matCellDef="let element"> <button mat-raised-button
                                                class="viewbet-button"
                                                (click)="onClickViewBets(element.match_id,element.event_id,element.type)">View
                                                Bets</button></td>
                                        <td mat-footer-cell *matFooterCellDef> </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="profitAndLossdisplayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: profitAndLossdisplayedColumns;"></tr>
                                    <tr mat-footer-row
                                        *matFooterRowDef="profitAndLossdisplayedColumns; sticky: true"></tr>
                                </table>
                                <mat-paginator [length]="profitandLossTotalItems" [pageSize]="50"
                                    [ngClass]="{'hide':profitDataLength==0 ,'show':profitDataLength!=0}"
                                    #profitPaginatorRef [pageIndex]="profitandLossPageIndex"
                                    [pageSizeOptions]="[50, 100,150, 200]" aria-label="Select page"
                                    (page)="profitLossData($event)">
                                </mat-paginator>
                                <div class="no-data-section row justify-content-center"
                                    *ngIf="profitandlossDataSource?.length == 0">

                                    <img src="assets/icons/mood_bad_black.png">
                                    <h1>Game History</h1>
                                    <label>There is no data to display</label>
                                </div>
                            </div>
                            <div class="tab-pane fade " id="onlineGamesReport">
                                <div class="row filter-section">
                                    <div class=" row col-md-12">
                                        <div class="col-md-1">
                                            <img src="assets/images/icon/filter-icon.png">
                                            <span>Filter</span>
                                        </div>
                                        <div class="form-group">
                                            <input class="form-control" [(ngModel)]="gameStartDate"
                                                [owlDateTime]="startDtOnlineGame"
                                                [owlDateTimeTrigger]="startDtOnlineGame"
                                                placeholder=" Start Date Time" [ngModelOptions]="{standalone: true}">
                                            <owl-date-time #startDtOnlineGame showSecondsTimer="true">
                                            </owl-date-time>
                                        </div>
                                        <div class="form-group">
                                            <input class="form-control" [(ngModel)]="gameEndDate" [ngModelOptions]="{standalone: true}"
                                                [owlDateTime]="endDtOnlineGame"
                                                [owlDateTimeTrigger]="endDtOnlineGame" placeholder=" End Date Time">
                                            <owl-date-time #endDtOnlineGame showSecondsTimer="true"></owl-date-time>
                                        </div>
                                        <div class="form-group">
                                            <select class="form-select">
                                                <option selected>Select Game Type</option>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                                <option value="200">200</option>
                                                <option value="500">500</option>
                                            </select>
                                        </div>
                                        <div class="form-group">
                                            <select class="form-select">
                                                <option selected>Result Type </option>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                                <option value="200">200</option>
                                                <option value="500">500</option>
                                            </select>
                                        </div>
                                        <div class="right-col col-md-3">
                                            <button class="submit-btn" (click)="clear()">Clear</button>
                                            <button class="submit-btn">Submit</button>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="form-group search" style="width:85%">
                                            <!-- <input class="form-control" type="text" placeholder="Search Bets" /> -->

                                        </div>
                                        <div class="form-group text-right" style="width:10%">
                                            <select class="form-select">
                                                <option selected value="25">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                                <option value="200">200</option>
                                                <option value="500">500</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>

                                <div class="no-data-section row justify-content-center">

                                    <img src="assets/icons/mood_bad_black.png">
                                    <h1>Game History</h1>
                                    <label>There is no data to display</label>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</main>

<app-footer-main></app-footer-main>

<!-- Date Time Picker -->
<ng-template #popTemplate>
    <datepicker [hidden]="!isDateVisible" [(ngModel)]="date" [ngModelOptions]="{standalone: true}" [minDate]="minDate" [maxDate] ="todayDateTime" [showWeeks]="false"
        (ngModelChange)="updateDate()" (selectionDone)="dateSelectionDone()">
    </datepicker>
    <timepicker [hidden]="!isDateVisible" [(ngModel)]="time" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateTime()" [showMeridian]="isMeridian" showSeconds="true">
    </timepicker>

    <div style="padding:5px">
        <span class="btn-group pull-left" style="margin-right:10px;">
            <button type=button class="btn btn-sm btn-info" [hidden]="!isDateVisible" (click)="today()">Today</button>
            <button type=button class="btn btn-sm btn-danger" (click)="clear()">Clear</button>
        </span>
        <span class="btn-group pull-right">
            <!-- <button type=button class="btn btn-sm btn-light" [hidden]="isDateVisible" 
            (click)="showDate()">Date
            </button>
            <button type=button class="btn btn-sm btn-light" [hidden]="!isDateVisible" 
            (click)="showTime()">Time
            </button> -->
            <button type=button class="btn btn-sm btn-success" (click)="close()">Close</button>
        </span> <span class=clearfix></span>
    </div>
</ng-template>
<ng-template #popTemplate1>
    <datepicker [hidden]="!isDateVisible" [(ngModel)]="endDate" [ngModelOptions]="{standalone: true}" [minDate]="date" [maxDate] ="todayDateTime" [showWeeks]="false"
        (ngModelChange)="updateEndDate()" (selectionDone)="dateSelectionDone()">
    </datepicker>
    <timepicker [hidden]="!isDateVisible" [(ngModel)]="endTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateEndTime()"
        [showMeridian]="isMeridian" showSeconds="true">
    </timepicker>

    <div style="padding:5px">
        <span class="btn-group pull-left" style="margin-right:10px;">
            <button type=button class="btn btn-sm btn-info" [hidden]="!isDateVisible" (click)="today()">Today</button>
            <button type=button class="btn btn-sm btn-danger" (click)="clear()">Clear</button>
        </span>
        <span class="btn-group pull-right">
            <!-- <button type=button class="btn btn-sm btn-light" [hidden]="isDateVisible" 
            (click)="showDate()">Date
            </button>
            <button type=button class="btn btn-sm btn-light" [hidden]="!isDateVisible" 
            (click)="showTime()">Time
            </button> -->
            <button type=button class="btn btn-sm btn-success" (click)="closeEndDatepicker()">Close</button>
        </span> <span class=clearfix></span>
    </div>
</ng-template>

<ng-template #popTemplateSettledStart>
    <datepicker [hidden]="!isDateVisible" [(ngModel)]="dateSettled" [ngModelOptions]="{standalone: true}" [minDate]="minDate" [maxDate] ="todayDateTime" [showWeeks]="false"
        (ngModelChange)="updateDateSettled()" (selectionDone)="dateSelectionDone()">
    </datepicker>
    <timepicker [hidden]="!isDateVisible" [(ngModel)]="timeSettled" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateTimeSettled()" [showMeridian]="isMeridian" showSeconds="true">
    </timepicker>

    <div style="padding:5px">
        <span class="btn-group pull-left" style="margin-right:10px;">
            <button type=button class="btn btn-sm btn-info" [hidden]="!isDateVisible" (click)="today()">Today</button>
            <button type=button class="btn btn-sm btn-danger" (click)="clear()">Clear</button>
        </span>
        <span class="btn-group pull-right">
            <!-- <button type=button class="btn btn-sm btn-light" [hidden]="isDateVisible" 
            (click)="showDate()">Date
            </button>
            <button type=button class="btn btn-sm btn-light" [hidden]="!isDateVisible" 
            (click)="showTime()">Time
            </button> -->
            <button type=button class="btn btn-sm btn-success" (click)="close()">Close</button>
        </span> <span class=clearfix></span>
    </div>
</ng-template>
<ng-template #popTemplateSettledEnd>
    <datepicker [hidden]="!isDateVisible" [(ngModel)]="endDateSettled" [ngModelOptions]="{standalone: true}" [minDate]="dateSettled" [maxDate] ="todayDateTime"[showWeeks]="false"
        (ngModelChange)="updateEndDateSettled()" (selectionDone)="dateSelectionDone()">
    </datepicker>
    <timepicker [hidden]="!isDateVisible" [(ngModel)]="endTimeSettled" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateEndTimeSettled()"
        [showMeridian]="isMeridian" showSeconds="true">
    </timepicker>

    <div style="padding:5px">
        <span class="btn-group pull-left" style="margin-right:10px;">
            <button type=button class="btn btn-sm btn-info" [hidden]="!isDateVisible" (click)="today()">Today</button>
            <button type=button class="btn btn-sm btn-danger" (click)="clear()">Clear</button>
        </span>
        <span class="btn-group pull-right">
            <!-- <button type=button class="btn btn-sm btn-light" [hidden]="isDateVisible" 
            (click)="showDate()">Date
            </button>
            <button type=button class="btn btn-sm btn-light" [hidden]="!isDateVisible" 
            (click)="showTime()">Time
            </button> -->
            <button type=button class="btn btn-sm btn-success" (click)="closeEndDatepicker()">Close</button>
        </span> <span class=clearfix></span>
    </div>
</ng-template>

<ng-template #popTemplateStatementStart>
    <datepicker [hidden]="!isDateVisible" [(ngModel)]="dateStatement" [ngModelOptions]="{standalone: true}" [minDate]="minDate"  [maxDate] ="todayDateTime"[showWeeks]="false"
        (ngModelChange)="updateDateStatement()" (selectionDone)="dateSelectionDone()">
    </datepicker>
    <timepicker [hidden]="!isDateVisible" [(ngModel)]="timeStatement" [ngModelOptions]="{standalone: true}" [min]="minTime" [max]="maxTime" (ngModelChange)="updateTimeStatement()" [showMeridian]="isMeridian" showSeconds="true">
    </timepicker>

    <div style="padding:5px">
        <span class="btn-group pull-left" style="margin-right:10px;">
            <button type=button class="btn btn-sm btn-info" [hidden]="!isDateVisible" (click)="today()">Today</button>
            <button type=button class="btn btn-sm btn-danger" (click)="clear()">Clear</button>
        </span>
        <span class="btn-group pull-right">
            <!-- <button type=button class="btn btn-sm btn-light" [hidden]="isDateVisible" 
            (click)="showDate()">Date
            </button>
            <button type=button class="btn btn-sm btn-light" [hidden]="!isDateVisible" 
            (click)="showTime()">Time
            </button> -->
            <button type=button class="btn btn-sm btn-success" (click)="close()">Close</button>
        </span> <span class=clearfix></span>
    </div>
</ng-template>
<ng-template #popTemplateStatementEnd>
    <datepicker [hidden]="!isDateVisible" [(ngModel)]="endDateStatement" [ngModelOptions]="{standalone: true}" [minDate]="dateStatement" [maxDate] ="todayDateTime" [showWeeks]="false"
        (ngModelChange)="updateEndDateStatement()" (selectionDone)="dateSelectionDone()">
    </datepicker>
    <timepicker [hidden]="!isDateVisible" [(ngModel)]="endTimeStatement" [ngModelOptions]="{standalone: true}" [min]="minTime" [max]="maxTime"  (ngModelChange)="updateEndTimeStatement()"
        [showMeridian]="isMeridian" showSeconds="true">
    </timepicker>

    <div style="padding:5px">
        <span class="btn-group pull-left" style="margin-right:10px;">
            <button type=button class="btn btn-sm btn-info" [hidden]="!isDateVisible" (click)="today()">Today</button>
            <button type=button class="btn btn-sm btn-danger" (click)="clear()">Clear</button>
        </span>
        <span class="btn-group pull-right">
            <!-- <button type=button class="btn btn-sm btn-light" [hidden]="isDateVisible" 
            (click)="showDate()">Date
            </button>
            <button type=button class="btn btn-sm btn-light" [hidden]="!isDateVisible" 
            (click)="showTime()">Time
            </button> -->
            <button type=button class="btn btn-sm btn-success" (click)="closeEndDatepicker()">Close</button>
        </span> <span class=clearfix></span>
    </div>
</ng-template>

<ng-template #popTemplateProfitStart>
    <datepicker [hidden]="!isDateVisible" [(ngModel)]="dateProfit" [ngModelOptions]="{standalone: true}" [minDate]="minDate"[maxDate] ="todayDateTime" [showWeeks]="false"
        (ngModelChange)="updateDateProfit()" (selectionDone)="dateSelectionDone()">
    </datepicker>
    <timepicker [hidden]="!isDateVisible" [(ngModel)]="timeProfit" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateTimeProfit()" [showMeridian]="isMeridian"showSeconds="true" >
    </timepicker>

    <div style="padding:5px">
        <span class="btn-group pull-left" style="margin-right:10px;">
            <button type=button class="btn btn-sm btn-info" [hidden]="!isDateVisible" (click)="today()">Today</button>
            <button type=button class="btn btn-sm btn-danger" (click)="clear()">Clear</button>
        </span>
        <span class="btn-group pull-right">
            <!-- <button type=button class="btn btn-sm btn-light" [hidden]="isDateVisible" 
            (click)="showDate()">Date
            </button>
            <button type=button class="btn btn-sm btn-light" [hidden]="!isDateVisible" 
            (click)="showTime()">Time
            </button> -->
            <button type=button class="btn btn-sm btn-success" (click)="close()">Close</button>
        </span> <span class=clearfix></span>
    </div>
</ng-template>
<ng-template #popTemplateProfitEnd>
    <datepicker [hidden]="!isDateVisible" [(ngModel)]="endDateProfit" [ngModelOptions]="{standalone: true}" [minDate]="dateProfit" [maxDate] ="todayDateTime" [showWeeks]="false"
        (ngModelChange)="updateEndDateProfit()" (selectionDone)="dateSelectionDone()">
    </datepicker>
    <timepicker [hidden]="!isDateVisible" [(ngModel)]="endTimeProfit" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateEndTimeProfit()"
        [showMeridian]="isMeridian" showSeconds="true">
    </timepicker>

    <div style="padding:5px">
        <span class="btn-group pull-left" style="margin-right:10px;">
            <button type=button class="btn btn-sm btn-info" [hidden]="!isDateVisible" (click)="today()">Today</button>
            <button type=button class="btn btn-sm btn-danger" (click)="clear()">Clear</button>
        </span>
        <span class="btn-group pull-right">
            <!-- <button type=button class="btn btn-sm btn-light" [hidden]="isDateVisible" 
            (click)="showDate()">Date
            </button>
            <button type=button class="btn btn-sm btn-light" [hidden]="!isDateVisible" 
            (click)="showTime()">Time
            </button> -->
            <button type=button class="btn btn-sm btn-success" (click)="closeEndDatepicker()">Close</button>
        </span> <span class=clearfix></span>
    </div>
</ng-template>